<template>
  <div class="q-pa-md">
    <!-- <div class="loaderClass" v-if="isLoading">
           <q-spinner-cube color="blue" size="6em"/>
    </div> -->
    <!-- <div class="q-pa-md" v-if="!isLoading && data.length != 0"> -->
   
    <div class="introWindow">
    <div>
      <h3 class="headi">Click on required row to get summary for that product</h3>
      </div>

      <div id="q-app" style="min-height: 100vh;">
  <div class="q-pa-md">
    <q-dialog
      v-model="fullWidth"
      full-width
    >
      <q-card>
        <q-card-section>
          <div class="text-h6">Inventory Summary Table</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
      <q-table
      class="my-sticky-virtscroll-table popuptable"
      virtual-scroll
      :virtual-scroll-sticky-size-start="48"
      row-key="index"
      title="Summary"
      :data="summary"
      :columns="columns2"
    >
   
    <template v-slot:header="props">
         <q-tr
            :props="props"
          >
            <q-th
              v-for="col in columns2"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr 
          :props="props" 
          >
            <!-- <q-td key="id" :props="props">
              Price_Optimization_Job_{{ props.row.jobnum}}
            </q-td> -->
             <q-td key="reorderdate" :props="props">
              {{ props.row.expected_day_of_reorder}}
            </q-td>
             <q-td key="product" :props="props">
              {{ props.row.item}}
            </q-td>
             <q-td key="shop" :props="props">
              {{ props.row.store}}
            </q-td>
            <q-td key="forecastedsales" :props="props">
              {{ props.row.forecasted_sales_summary}}
            </q-td>
            <q-td key="unitcostprice" :props="props">
              {{ props.row.price}}
            </q-td>
            <q-td key="unitrevenue" :props="props">
              {{ props.row.unit_revenue_summary}}
            </q-td>
            <q-td key="esimatedrevenue" :props="props">
              {{ props.row.estimated_revenue_summary}}
            </q-td>
            <q-td key="closinginventory" :props="props">
              {{ props.row.closing_inventory_summary}}
            </q-td>
             <q-td key="stockoutstatus" :props="props">
              {{ props.row.Stock_out_summary}}
            </q-td>
            <q-td key="reorderstatus" :props="props">
              {{ props.row.reorder_status_summary}}
            </q-td>
            <q-td key="reorder_quantity" :props="props">
              {{ props.row.estimated_reorder_amount}}
            </q-td>
           
             <!-- <q-td key="job_progress" auto-width>
              <q-btn
                unelevated
                size="12px"
                rounded
                color="blue"
                label="Show Summary"
                class="text-white"
                @click="fullwidth = true"
              />
              </q-td> -->


          </q-tr>
          </template>
    </q-table>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn flat label="OK" v-close-popup></q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-table
      class="my-sticky-virtscroll-table"
      virtual-scroll
      :virtual-scroll-sticky-size-start="48"
      row-key="index"
      title="Inventory optimization Results page"
      :data="data"
      :columns="columns"
      :filter="filter"
    >
     <template v-slot:top-right>
        <q-input
          dense
          debounce="300"
          placeholder="Search"
          v-model="filter"
          @input="
            (val) => {
              searchHandler(val);
            }
          "
        >
          <q-icon slot="append" name="search" />
        </q-input>
      </template>
    <template v-slot:header="props">
         <q-tr
            :props="props"
          >
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template v-slot:body="props">
          <q-tr 
          :props="props" 
          class="cursor-pointer"
          @click.native="onRowClick(props.row)"
           
          >
            <!-- <q-td key="id" :props="props">
              Price_Optimization_Job_{{ props.row.jobnum}}
            </q-td> -->
             <q-td key="reorderdate" :props="props">
              {{ props.row.expected_day_of_reorder}}
            </q-td>
             <q-td key="product" :props="props">
              {{ props.row.item}}
            </q-td>
             <q-td key="shop" :props="props">
              {{ props.row.store}}
            </q-td>
            <q-td key="costprice" :props="props">
              {{ props.row.price}}
            </q-td>
             <q-td key="reorder_quantity" :props="props">
              {{ props.row.reorder_quantity}}
            </q-td>
             <q-td key="maximumbudget" :props="props">
              {{ props.row.estimated_reorder_amount}}
            </q-td>
             <!-- <q-td key="job_progress" auto-width>
              <q-btn
                unelevated
                size="12px"
                rounded
                color="blue"
                label="Show Summary"
                class="text-white"
                @click="fullwidth = true"
              />
              </q-td> -->


          </q-tr>
          </template>
    </q-table>
  </div>
  
</div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      fullWidth:false,
      summary:[],
      columns: [
        // {
        //   name: "id",
        //   align: "left",
        //   label: "Job Submission Number",
        //   field: "id",
        //   sortable: true,
        // },
        {
          name: "reorderdate",
          align: "left",
          label: "Reorder Date",
          field: "reorderdate",
          sortable: true,
        },
        {
          name: "product",
          label: "Product",
          field: "product",
          align: "left",
          sortable: true,
          headerStyle: "width: 200px",
        },
        {
          name: "shop",
          label: "Shop",
          field: "shop",
          align: "left",
        },
         {
          name: "costprice",
          label: "Cost Price",
          field: "costprice",
          align: "center",
        },
        {
          name: "reorder_quantity",
          label: "Reorder Quantity",
          field: "reorder_quantity",
          align: "center",
        },
        {
          name: "maximumbudget",
          label: "Estimated reorder Amount",
          field: "maximumbudget",
          align: "center",
        },
        // {
        //   name: "job_progress",
        //   label: "Job progress",
        //   field: "job_progress",
        //   align: "center",
        //   hidden:true,
        // },
      ],
      columns2: [
       {
          name: "reorderdate",
          align: "left",
          label: "Reorder Date",
          field: "reorderdate",
          sortable: true,
        },
        {
          name: "product",
          label: "Product",
          field: "product",
          align: "left",
          sortable: true,
          headerStyle: "width: 200px",
        },
        {
          name: "shop",
          label: "Shop",
          field: "shop",
          align: "left",
        },
         {
          name: "forecastedsales",
          label: "Forecasted Sales",
          field: "forecastedsales",
          align: "left",
        },
         {
          name: "costprice",
          label: "Unit Cost Price",
          field: "costprice",
          align: "center",
        },
         {
          name: "revenue",
          label: "Unit Revenue",
          field: "revenue",
          align: "left",
        },
         {
          name: "estimatedrevenue",
          label: "Estimated Revenue",
          field: "estimatedrevenue",
          align: "left",
        },
         {
          name: "closinginventory",
          label: "Closing Inventory",
          field: "closinginventory",
          align: "left",
        },
         {
          name: "stockoutstatus",
          label: "Stock Out Status",
          field: "stockoutstatus",
          align: "left",
        },
         {
          name: "reorderstatus",
          label: "Reorder Status",
          field: "reorderstatus",
          align: "left",
        },
        {
          name: "reorder_quantity",
          label: "Reorder Quantity",
          field: "reorder_quantity",
          align: "center",
        },
       
      ],
      filter: "",
      data:[],
    };
  },
 
  computed:{
    

  },
  mounted(){
    this.$q.loading.show({
       message: "Authenticating please wait..",
     });


      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/inventoryoptimization/inventoryrecommendations");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/inventoryoptimization/inventoryrecommendations");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else{
       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
     }
  },
  methods: {
    searchHandler(value) {
      if (value.length >= 3) {
        let searchResult = this.backupList.filter((item) => {
          return item.title.toLowerCase().includes(value.toLowerCase());
        });
        this.data = searchResult;
      } else {
        this.data = this.backupList;
      }
    },
     onRowClick(row){
       this.summary[0] = row;
       console.log(this.summary)
      this.fullWidth = true
      //  this.selected = row;
      // console.log(this.selected);
      // this.$router.push({
      //   name: "InventorySummary",
        // params: {
        //   items: row,
        //   jobid:this.$route.params.jobid
        // },
      // });
    },
   
    showResult(data) {
      // const id = this.data[]
      // let jobnum = 0; 
      // for(var i=0;i<this.data.length;++i){
      //   if(data === this.data[i]['id']){
      //     let num = i;
      //     jobnum = num;
      //     console.log(num)
      //   }
      // }
      // console.log(jobnum)
       this.$router.push({
      name: "InventoryResults",
      params: {
        jobid: data,
       },
       });
    //   if(this.data[jobnum]['request_type'] === "pricing-revenue"){
    //   this.$router.push({
    //     name: "PriceOptimizationResults",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    //   }else if(this.data[jobnum]['request_type'] === "pricing-volume"){
    //      this.$router.push({
    //     name: "VolumeRecommendation",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    //   }else if(this.data[jobnum]['request_type'] === "pricing-profit"){
    //      this.$router.push({
    //     name: "ProfitRecommendation",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    //   }else{
    //   this.$router.push({
    //     name: "PriceOptimizationResults",
    //     params: {
    //       jobid: data,
    //     },
    //   });
    // }
  },
  },
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

.headi{
   color:rgb(33, 103, 233);
   font-family: "Poppins", sans-serif !important;
   font-size:25px;
}
.popuptable .q-table__middle{
  max-height:100%;
}

.heading {
  font-family: "Montserrat", sans-serif;
  color: blue;
  font-size: 1.5rem;
}

.introWindow {
  text-align: center;
  border-radius: 4px;
  padding: 1rem 1rem 0;
  background: transparent;
  /* background-image: radial-gradient(circle, #2678ca, #082f7a); */
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); */
  transition: 0.3s;
  height: 100vh;
}

.loaderClass {
  margin: 40vh 0 0 40%;
}

.nodata {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 50%;
  text-align: center;
  height: 100px;
  padding-top: 2.5rem;
  margin-top: 40vh;
  margin-left: 25%;
}

.box-h {
  align-items: center;
  background-color: #2db051;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.fit{
   border-top-left-radius: 0px !important;
   border-bottom-right-radius: 0px !important;
   border-bottom-left-radius: 0px !important;
   background: white!important;
box-shadow: 0px 3px 6px #00000030;


}

.box-m {
  align-items: center;
  background-color: #fb9300;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.my-sticky-virtscroll-table {
  /* height or max-height is important */
  height: 410px;
  /* this will be the loading indicator */ }
  .my-sticky-virtscroll-table .q-table__top,
  .my-sticky-virtscroll-table .q-table__bottom,
  .my-sticky-virtscroll-table thead tr:first-child th {
    background-color: #fff; }
  .my-sticky-virtscroll-table thead tr th {
    position: sticky;
    z-index: 1; }
  .my-sticky-virtscroll-table thead tr:last-child th {
    /* height of all previous header rows */
    top: 48px; }
  .my-sticky-virtscroll-table thead tr:first-child th {
    top: 0; }

</style>



